// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"319b33b5","354":"4ff67c2d","456":"c434f196","542":"319b33b5","799":"eb8ee359"}[chunkId] + ".chunk.css";
};